"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.182 1v9.036c0 .104.043.204.12.278a.42.42 0 00.29.115H21V22.41c0 .156-.064.306-.18.416s-.27.173-.433.173H3.614a.627.627 0 01-.434-.173.578.578 0 01-.18-.416V1.589c0-.156.065-.306.18-.416A.627.627 0 013.614 1zm1.636 7.66V1.477a.097.097 0 01.063-.091.103.103 0 01.112.021l7.584 7.284a.094.094 0 01.022.107c-.008.018-.02.033-.038.044s-.036.016-.056.016h-7.482a.209.209 0 01-.145-.057.193.193 0 01-.06-.14z",
    clipRule: "evenodd"
  }));
}

var _default = 'src/asset/icon/terms-and-services.icon.svg';
exports.default = _default;
//# sourceMappingURL=terms-and-services.icon.js.map